import * as F06_03P1 from "./06_03/Page1";

const Pages = {
    '06_03': {
        1: ['/facsimile/vilshofen/06_03_Ankuendigung/vilshofen_bild_0016.jpg', F06_03P1],
    },
};

export {Pages};
